import type { RumInitConfiguration } from '@datadog/browser-rum';
import type { LoggingConfig } from '@presencelearning/logging';
import { releaseVersion } from '../environments/release';

const SERVICE = 'future-client';
const SITE = 'datadoghq.com';

/**
 * Logging-package init. Empty client token leaves logging off, matching local
 * dev. Browser-logs 7 does not capture console.error via forwardErrorsToLogs,
 * so warn and error are forwarded explicitly.
 */
export function logsInitConfiguration(clientToken: string, env: string): LoggingConfig | null {
  if (!clientToken) {
    return null;
  }
  return {
    clientToken,
    site: SITE,
    service: SERVICE,
    env,
    version: releaseVersion,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['warn', 'error'],
  };
}

/** RUM init. Empty application id or client token leaves RUM off. */
export function rumInitConfiguration(
  applicationId: string,
  clientToken: string,
  env: string
): RumInitConfiguration | null {
  if (!applicationId || !clientToken) {
    return null;
  }
  return {
    applicationId,
    clientToken,
    site: SITE,
    service: SERVICE,
    env,
    version: releaseVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  };
}
